module.exports = __webpack_public_path__ + "static/scale-model-of-classic-group-tours-in-odessa-texas-812bb3ba6bc02f6fef9cff2c61503d40.png";